// Logbook column visibility is independent of the report's grouping identity.
export const buildTaskListColumns = (groupBy = []) => {
   const columns = {
      operation: { visible: !groupBy.includes('opName') },
      location: { visible: !groupBy.includes('location') },
      assignee: { visible: !groupBy.includes('assignee') },
      doneBy: { visible: true },
      startsFrom: { visible: true },
      status: { visible: !groupBy.includes('status') },
      score: { visible: !groupBy.includes('score') },
      flagged: { visible: true }
   };
   columns.noOfColumns = Object.values(columns).filter((column) => column.visible).length;
   return columns;
};
